jQuery(document).ready(function () {
    jQuery(".m-resources li").slice(0, 10).addClass('visible'); // select the first ten
    jQuery(".m-resources__see-more").click(function (e) { // click event for load more
        e.preventDefault();
        jQuery(".m-resources li:hidden").slice(0, 10).fadeIn(); // select next 10 hidden divs and show them
        if (jQuery(".m-resources li:hidden").length == 0) { // check if any hidden divs still exist
            jQuery(".m-resources__see-more").hide();
        }
    });
    if (jQuery(".m-resources li:hidden").length == 0) { // check if any hidden divs still exist
        jQuery(".m-resources__see-more").hide();
    }

});

